// Recover a stale Radix body lock only after its overlays (and any parents) exit.
// A child Select closing must never unlock the page behind an active Dialog.
const OVERLAY_SELECTOR = '[data-pointer-lock-overlay], [role="dialog"][data-state], [role="alertdialog"][data-state], [role="menu"][data-state]';
let observer = null;
let frame = null;

function stopWatching() {
  observer?.disconnect();
  observer = null;
  if (frame !== null) window.cancelAnimationFrame(frame);
  frame = null;
}

function hasVisibleOverlay() {
  return [...document.querySelectorAll(OVERLAY_SELECTOR)].some((element) => {
    if (element.hidden || !element.getClientRects().length) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  });
}

function recoverPointerEvents() {
  frame = null;
  if (!document.body || document.body.style.pointerEvents !== 'none') {
    stopWatching();
    return;
  }
  // Keep watching while nested parents or exit animations still own the lock.
  if (hasVisibleOverlay()) return;
  stopWatching();
  document.body.style.removeProperty('pointer-events');
}

function afterRadixCleanup() {
  if (frame !== null) return;
  // Let React/Radix unmount and focus restoration finish before checking.
  frame = window.requestAnimationFrame(() => {
    frame = window.requestAnimationFrame(recoverPointerEvents);
  });
}

export function releaseStaleOverlayPointerEvents() {
  if (typeof document === 'undefined' || typeof window === 'undefined' || !document.body) return;
  if (!observer) {
    observer = new MutationObserver(afterRadixCleanup);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['style', 'class', 'data-state', 'hidden'] });
  }
  afterRadixCleanup();
}